import React from 'react';
import type { BrandTeamSession } from '../../../../services/brandTeamService';

interface SessionListProps {
  sessions: BrandTeamSession[];
  activeSessionId: string | null;
  onSelect: (sessionId: string) => void;
}

const statusDot: Record<string, string> = {
  generated: 'bg-green-500',
  generating: 'bg-brand-purple animate-pulse',
  planning: 'bg-brand-purple animate-pulse',
  generation_failed: 'bg-red-500',
};

const SessionList: React.FC<SessionListProps> = ({ sessions, activeSessionId, onSelect }) => {
  return (
    <div className="border-t border-primary-100 px-3 py-3">
      <h4 className="mb-2 text-[10px] font-semibold uppercase tracking-wider text-body-grey">Recent Sessions</h4>
      <div className="space-y-0.5 max-h-36 overflow-y-auto">
        {sessions.slice(0, 8).map((s) => (
          <button
            key={s.id}
            type="button"
            onClick={() => onSelect(s.id)}
            className={`flex w-full items-center gap-2 rounded-lg px-2.5 py-2 text-left transition-colors ${
              s.id === activeSessionId ? 'bg-primary-50 border border-primary-200' : 'hover:bg-gray-50'
            }`}
          >
            <span className={`h-2 w-2 flex-shrink-0 rounded-full ${statusDot[s.status] || 'bg-gray-300'}`} />
            <span className="flex-1 truncate text-[11px] font-medium text-text-dark">{s.name || 'Untitled'}</span>
            <span className="text-[9px] text-gray-400 capitalize">{s.status.replace(/_/g, ' ')}</span>
          </button>
        ))}
        {sessions.length === 0 && <p className="text-[11px] text-gray-400 italic px-2">No sessions yet</p>}
      </div>
    </div>
  );
};

export default SessionList;
